var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#6F52EA",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2440 4604 c-121 -15 -238 -39 -326 -69 -493 -164 -848 -562 -960 -1075 -18 -79 -19 -142 -19 -895 0 -756 1 -816 19 -900 107 -512 466 -916 960 -1080 152 -51 266 -68 446 -69 180 0 294 18 446 69 257 86 474 232 646 435 173 205 282 442 324 710 13 80 14 217 11 875 -4 865 0 814 -73 1035 -96 289 -298 552 -561 728 -146 98 -364 186 -538 217 -90 16 -310 27 -375 19z m326 -219 c173 -30 327 -92 476 -191 228 -152 404 -384 486 -645 58 -180 57 -171 57 -994 0 -698 -1 -767 -18 -843 -74 -336 -255 -607 -527 -787 -207 -138 -429 -205 -680 -205 -251 0 -473 67 -682 206 -270 180 -453 454 -525 787 -16 74 -18 153 -18 847 0 838 -1 825 62 1010 141 417 513 736 948 814 108 19 312 20 421 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 3448 l0 -543 -223 223 -222 222 -68 -68 c-37 -37 -67 -72 -67 -77 0 -6 141 -151 313 -322 204 -204 322 -314 339 -318 16 -4 40 -4 55 0 18 4 136 114 341 318 171 171 312 316 312 322 0 5 -30 40 -67 77 l-68 68 -222 -222 -223 -223 0 543 0 542 -100 0 -100 0 0 -542z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.f77b99fcf03753703912535fe708f9e7.svg";
export { ForwardRef as ReactComponent };